var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { API_PATHS, reportsDownloadFileId } from "../types/apiPaths";
import { getHeaders } from "../utils/apiUtils";
// large-library report can take tens of seconds on cold cache; ky default would abort it
var REPORT_TIMEOUT_MS = 120000;
var postReport = function (ky, path, params, options) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, ky.post(path, __assign({ headers: getHeaders(), json: params }, options))];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Report error: ".concat(response.status));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_1 = _a.sent();
                console.error("Error generating report:", error_1);
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var generateKult1501Report = function (ky, params) {
    return postReport(ky, API_PATHS.REPORTS_KULT_15_01, params, { timeout: REPORT_TIMEOUT_MS });
};
export var generateKult1501Xlsx = function (ky, params) {
    return postReport(ky, API_PATHS.REPORTS_KULT_15_01_EXPORT, params, {
        searchParams: { format: "XLSX" },
        timeout: REPORT_TIMEOUT_MS,
    });
};
export var generateKult0501Report = function (ky, params) {
    return postReport(ky, API_PATHS.REPORTS_KULT_05_01, params, { timeout: REPORT_TIMEOUT_MS });
};
export var generateKult0501Xlsx = function (ky, params) {
    return postReport(ky, API_PATHS.REPORTS_KULT_05_01_EXPORT, params, {
        searchParams: { format: "XLSX" },
        timeout: REPORT_TIMEOUT_MS,
    });
};
export var fetchKultSubjectGroups = function (ky) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, ky.get(API_PATHS.REPORTS_KULT_05_01_SUBJECT_GROUPS, {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Subject group codelist error: ".concat(response.status));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_2 = _a.sent();
                console.error("Error fetching KULT subject groups:", error_2);
                throw error_2;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var downloadReportAndSave = function (ky, fileId, fileName) { return __awaiter(void 0, void 0, void 0, function () {
    var response, blob, url, link, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, ky.get(reportsDownloadFileId(fileId), {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Download error: ".concat(response.status));
                }
                return [4 /*yield*/, response.blob()];
            case 2:
                blob = _a.sent();
                url = URL.createObjectURL(blob);
                link = document.createElement("a");
                link.href = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                link.remove();
                URL.revokeObjectURL(url);
                return [3 /*break*/, 4];
            case 3:
                error_3 = _a.sent();
                console.error("Error downloading report:", error_3);
                throw error_3;
            case 4: return [2 /*return*/];
        }
    });
}); };
